export const handleCopy = codeToCopy => {
	navigator.clipboard.writeText(codeToCopy);
};

/**
 * @function sendDataToAnalytics
 * This function will call window.gtag function with event name and event data from analyticsInfo object. This would send these data to Google Analytics
 * @param {Object} analyticsInfo
 * @param {string} analyticsInfo.eventName
 * event Name
 * @param {string} analyticsInfo.eventData
 * event Data object to send additional data along with event name.
 */
export const sendDataToAnalytics = analyticsInfo => {
	if (window.gtag) {
		window.gtag('event', analyticsInfo?.eventName, {
			...analyticsInfo?.eventData,
		});
	}
};
